import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UaService } from '@ecm/consumer';
import { EnvUtils } from '@ecm/dispatcher';
import { EcmMaterialModule } from '@ecm/material';
import { LinkService, RouterService } from '@ecm/router';

import { DashboardRelationalViewModel } from '../../../business/model/home/dashboard/dashboard-relational.view-model';
import { TmsCodes } from '../../../business/model/tracking/tmsCodes.enum';
import { ImageUtils } from '../../../utils/image.utils';
import { ParamsUtils } from '../../../utils/params.utils';
import { AbstractParentComponent } from '../../shared/abstract-parent.component';
import { AdviseWhitelistEclairConstants } from '../../shared/advise-whitelist-eclair.constants';

@Component({
    selector: 'relational-recommendation',
    templateUrl: 'relational-recommendation.html',
    styleUrls: ['relational-recommendation.css'],
    standalone: true,
    imports: [EcmMaterialModule],
})
export class RelationalRecommendationComponent extends AbstractParentComponent implements OnInit {
    @Input()
    public viewModel: DashboardRelationalViewModel;

    protected readonly AdviseWhitelistEclairConstants = AdviseWhitelistEclairConstants;
    public zid!: string;
    public isEclair!: boolean;

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        protected route: ActivatedRoute,
        public linkService: LinkService,
    ) {
        super(uaService, routerService, route);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.isEclair = EnvUtils.isEclair();
        this.isSoshBrand().subscribe((isSosh: boolean) => {
            if (isSosh) {
                this.zid = this.isMobile
                    ? TmsCodes.care_digital_relational_sosh_zidMob
                    : TmsCodes.care_digital_relational_sosh_zid;
            } else {
                this.zid = this.isMobile
                    ? TmsCodes.care_digital_relational_zidMob
                    : TmsCodes.care_digital_relational_zid;
            }
        });
    }

    public openRelationalLink(): void {
        if (this.viewModel.cid) {
            this.viewModel.trackingData.cappingTracking.cid = this.viewModel.cid;
        }
        this.linkService.openLink(
            this.viewModel.link,
            this.viewModel.trackingData,
            ParamsUtils.cidMap(this.viewModel.cid),
        );
    }

    public getImgFormat(imgurl: string) {
        return ImageUtils.transformUrl(imgurl, '32');
    }
}
